const EXPERIMENTS = {
  CHECKOUT_SAVINGS: 'enable_experiment_checkout_savings',
  AGREE_TO_TERMS: 'enable_experiment_agree_to_terms',
  FEATURE_LIST: 'enable_experiment_feature_list'
}

const HOURS_THRESHOLD = 24 // Hours before disabling an experiment.

const SessionStorage = {
  /**
   * Get an item from sessionStorage.
   * @param {string} key - The key of the item to retrieve.
   * @returns {any} The parsed value from sessionStorage, or null if not found.
   */
  get(key) {
    const item = sessionStorage.getItem(key)
    try {
      return JSON.parse(item) // Parse JSON if possible
    } catch {
      return item // Return raw value if parsing fails
    }
  },

  /**
   * Write an item to sessionStorage.
   * @param {string} key - The key to store the value under.
   * @param {any} value - The value to store. Will be stringified if it's an object.
   */
  write(key, value) {
    const item = typeof value === 'object' ? JSON.stringify(value) : value
    sessionStorage.setItem(key, item)
  },

  /**
   * Delete an item from sessionStorage.
   * @param {string} key - The key of the item to remove.
   */
  delete(key) {
    sessionStorage.removeItem(key)
  },

  /**
   * Clear all items from sessionStorage.
   */
  clear() {
    sessionStorage.clear()
  }
}

const updateCartAttributes = (attribute) => {
  const attributes = {
    ...attribute
  }

  return fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ attributes })
  })
  .catch((error) => {
    console.error('Error updating cart attributes:', error)
  })
}

const enableExperiment = (experiment) => {
  SessionStorage.write(experiment, { timestamp: Date.now() })
  updateCartAttributes({ [experiment]: true })
}

const disableExperiment = (experiment) => {
  SessionStorage.delete(experiment)
  updateCartAttributes({ [experiment]: null })
}

const hasExpired = (timestamp) => {
  const elapsedHours = (Date.now() - timestamp) / (1000 * 60 * 60)
  return elapsedHours > HOURS_THRESHOLD
}

const cleanUpExpiredExperiments = () =>
  Object.values(EXPERIMENTS).forEach((experiment) => {
    const data = SessionStorage.get(experiment)  
    if (!data) return
    if (hasExpired(data.timestamp)) disableExperiment(experiment)
  })

// Clean up expired experiments on page load.
cleanUpExpiredExperiments()

// Expose API for A/B testing.
document.addEventListener('DOMContentLoaded', () => {
	if (!window.abEvents) return
	
	window.abEvents.subscribe('checkout.checkoutSavings', () => {
		enableExperiment(EXPERIMENTS.CHECKOUT_SAVINGS)
	})

	window.abEvents.subscribe('checkout.agreeToTerms', () => {
    enableExperiment(EXPERIMENTS.AGREE_TO_TERMS)
	})

  window.abEvents.subscribe('checkout.featureList', () => {
    enableExperiment(EXPERIMENTS.FEATURE_LIST)
	})
})